import React, { useLayoutEffect, useRef } from "react";
import { useQuery } from '@tanstack/react-query';
import { slick } from "@accessible360/accessible-slick";
import * as QUERIES from "../query-functions";

const above_breakpoint = window.matchMedia("(min-width: 75em)").matches;

// This doesn't use the CardCarousel componenet because it has to init the carousel on injected html
const TopPicks = (props) => {
    const containerRef = useRef(null);

    const { 
        data: topPicksData,
    } = useQuery({
        queryKey: ['getTopPicks'],
        queryFn: () => QUERIES.getTopPicks(props.origin),
        refetchOnWindowFocus: false,
        retry: false
    });

    useLayoutEffect(() => {
        if (!topPicksData || !containerRef.current) return;

        // Inject HTML once
        const parser = new DOMParser();
        const doc = parser.parseFromString(topPicksData, "text/html");
        containerRef.current.innerHTML = doc.body.innerHTML;

        if (!above_breakpoint) return;
        // Wait for DOM to render
        const timeout = setTimeout(() => {
            const carousel = containerRef.current.querySelector("[data-carousel]");
            if (!carousel) return;

            const arrow = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22"><path fill-rule="evenodd" d="M10.6 21.3a1 1 0 0 1-1-1V3.4l-7.9 8A1 1 0 0 1 .3 9.8L9.9.3a1 1 0 0 1 1.4 0L21 9.9a1 1 0 0 1-1.5 1.4l-7.9-7.9v16.9c0 .5-.4 1-1 1Z" clip-rule="evenodd"/></svg>`;
            
            const slickProps = {
                dots: false,
                arrows: true,
                infinite: false,
                speed: 300,
                slidesToShow: 2,
                adaptiveHeight: false,
                arrowsPlacement: "afterSlides",
                prevArrow: '<button type="button" data-control-prev><span class="sr-text">Previous</span>' + arrow + "</button>",
                nextArrow: '<button type="button" data-control-next><span class="sr-text">Next</span>' + arrow + "</button>",
            };

            $(carousel).slick(slickProps);
        }, 0);

        return () => clearTimeout(timeout); // cleanup
    }, [topPicksData]);

    if (!topPicksData) return null;

    return (
        <div ref={containerRef} className={`top-picks__${props.origin} card-carousel__container`} />
    );
};

export default TopPicks;
